import { ThunkAction } from 'redux-thunk';
import { fetchProductsAction } from '../../modules/ScrShopNew/store/slices/products';
import { RootState } from 'old-store/store';

type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, any>;

type AppInstallationState = string;

export const setAppInstallationState =
  (payload: AppInstallationState): AppThunk =>
  (dispatch) => {
    try {
      dispatch({ type: 'set_app_installation_state', payload });
    } catch (e) {
      console.log(e);
    }
  };

export const showAppInstallationAlertHint = (): AppThunk => (dispatch) => {
  try {
    dispatch({ type: 'show_app_installation_alert_hint' });
  } catch (e) {
    console.log(e);
  }
};

export const confirmSingleImageDownloadHint = (): AppThunk => (dispatch) => {
  try {
    dispatch({ type: 'confirm_single_image_dl_hint' });
  } catch (e) {
    console.log(e);
  }
};

export const fetchProducts = (): AppThunk => (dispatch) => {
  try {
    dispatch(fetchProductsAction());
  } catch (e) {
    console.log('e', e);
  }
};
